import styled from "styled-components";

export const MessageContainer = styled.div`
  margin: ${({ margin }) => (margin ? margin : "20px auto")};
  padding: 10px;
  width: 100%;
  max-width: 860px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  border: 1px #f15a24 solid;
  border-left: 8px #f15a24 solid;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const MessageImg = styled.img`
  width: 34px;
  height: 31px;
`;
export const MessageText = styled.p`
  margin-left: 10px;
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #f15a24;
`;
export const DismissButton = styled.button`
  margin-left: 10px;
  padding: 8px 24px;
  background-color: #f15a24;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: #d94d1e;
  }
`;
